// extracted by mini-css-extract-plugin
module.exports = {"file":"File_file__2qV9X","fileDisabled":"File_fileDisabled__1PsGi"};